<!-- <input [checked]="ischecked" type="checkbox" /> -->
<iscustomcheckbox
  (click)="check()"
  [formControl]="formControl"
></iscustomcheckbox>

<!--<mat-icon>sync</mat-icon>-->
